import { Box, Button, Grid } from '@mui/material';

const BottomButtonContainer: React.FC<any> = ({ disabled, handleMethod, buttonText }: any) => {
    return (
        <Box display="flex" justifyContent="center">
            <Grid container sx={{ mt: 2 }}>
                <Grid item>
                    <Button
                        variant="outlined"
                        color="primary"
                        disabled={disabled}
                        onClick={handleMethod}
                        size="large"
                    >
                        {buttonText}
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};

export default BottomButtonContainer;
